import RegionSelect from './region-select';

export default RegionSelect;
